import { Component, OnInit, ElementRef, ViewChild, Inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { AuthenticationService, DataService, ToastrService, WindowRefService, ICustomWindow } from '../../_services/index';
// import { DOCUMENT } from "@angular/platform-browser";
import { DOCUMENT } from "@angular/common";
import 'rxjs/Rx';
import * as _ from 'lodash';
import { Subject } from 'rxjs/Subject';
import { DownloadComponent } from './download/download.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterPipe } from "../../_pipes/filter.pipe";
import { FileSizeFormatterPipe } from "../../_pipes/file-size-formatter.pipe";
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-my-content',
    templateUrl: './my-content.component.html',
    styleUrls: ['./my-content.component.css'],
    providers: [
        FilterPipe,
        FileSizeFormatterPipe,
        ToastrService,
        // { provide: Window, useValue: window }
    ]
})
export class MyContentComponent implements OnInit, OnDestroy {
    model: any = {};
    private collOfChildren: Array<DownloadComponent> = [];
    myContents: Array<any> = [];
    private bundleContent: Array<any> = [];
    searchText: any;
    isDownload: boolean;
    payload: any;
    role: string;
    sortingType: Array<any> = [
        { id: '', name: 'Sort By:' },
        { id: 'az', name: 'A-Z' },
        { id: 'za', name: 'Z-A' }
    ];
    user: any;
    menuEnableDisableToggle: boolean;
    menuToggleEnableDisable: string;
    dtTrigger: Subject<any> = new Subject();
    // srollObserverSubscription: any;
    searchObserverSubscription: any;
    routeNavigatorSubscription: any;
    scroller: { x: number, y: number };
    isContentRendered: boolean = false;
    isBackToTop: boolean = false;

    // @ViewChild('scroll', { read: ElementRef }) public scroll: ElementRef;
    title = 'Hard Hitter@Cool';
    navIsFixed: boolean;
    currentPageName: string = 'home';
    contentScrollTop:number = 0;
    constructor(@Inject(DOCUMENT) private document: Document
        , private window: WindowRefService,
        private _dataService: DataService,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _authenticationService: AuthenticationService,
        private spinner: NgxSpinnerService,
        private searchPipe: FilterPipe,
        public _toastrService: ToastrService
        // , @Inject(Window) private window: Window
    ) {
        this.model.selectedSortingType = this.sortingType[0];

        this.searchObserverSubscription = this._dataService.searchTextObservable.subscribe(lastSearchVal => {
            console.log('search', lastSearchVal);
            this.searchText = lastSearchVal;
        });
        
    }

    ngOnInit() {
        this.role = this._authenticationService.getRole();
        if (this.role !== 'admin' && this.role !== 'super_admin' && this.role !== 'content_admin') {
            this.sortingType.push({ id: 'new', name: 'Newest-Oldest' });
            this.sortingType.push({ id: 'old', name: 'Oldest-Newest' });
        } else {
            this.sortingType = [
                { id: '', name: 'Sort By:' },
                { id: 'az', name: 'A-Z' },
                { id: 'za', name: 'Z-A' }
            ];
        }

        this.isDownload = false;
        this.menuToggleEnableDisable = "collapse navbar-collapse text-center justify-content-end"
        this.getMyContent();
        this.scroller = this._dataService.scrollMemory[this.currentPageName].curr;

        /*Page's GA data */
        (<any>window).gtag('config', environment.gaId, { 'page_path': `/home` });
        this.getContentScrolltop((top)=>{
            this.contentScrollTop = top;
        })
    }

    setNavFixedValue(val) {
        this.navIsFixed = val;
        this.isBackToTop = false;
    }
    
    onEdit() {
        this.isBackToTop = true;
        $(".app-scrollable-content").animate({scrollTop: 0});
        // this.window.nativeWindow.scrollTo({ top: 0 });
    }

    getContentScrolltop(cb) {
        let scrolltop = 0;
        $(".app-scrollable-content").scroll(()=>{
            scrolltop = $(".app-scrollable-content").scrollTop();
            cb(scrolltop);
        });
    }

    getMyContent = () => {

        this.payload = this._authenticationService.getUserInfo();
        const url = '/auth/getMyContent';

        let contentCache:any = sessionStorage.getItem('productListCache');
        let loadHomeFromSession = sessionStorage.getItem('loadHomeFromSession');
        if(loadHomeFromSession) sessionStorage.removeItem('loadHomeFromSession');
        if(!contentCache || !loadHomeFromSession) contentCache = {};
        try{
            this.myContents = JSON.parse(contentCache);
        } catch(e) {
            this._dataService.get(url).subscribe((data: { data: any, response: string, response_message: Array<any> }) => {
                this.myContents = data.data;
                sessionStorage.setItem('productListCache', JSON.stringify(this.myContents));
            }, (error) => {
                this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                this.spinner.hide();
            });
        }

        
    }

    searchContent(val) {
        this._dataService.searchTextSubject.next(val);
    }

    verifyDownloadable(val) {
        console.log(val)
        if (val === 0) {
            this._toastrService.typeCustomError(`You don't have access to download this product.`);
        }
    }

    sortContents(sorting) {
        if (sorting.id === 'az') {
            this.myContents = _.orderBy(this.myContents, ['display_name'], ['asc']);
        } else if (sorting.id === 'za') {
            this.myContents = _.orderBy(this.myContents, ['display_name'], ['desc']);
        } else if (sorting.id === 'new') {
            this.myContents = _.orderBy(this.myContents, (o) => {
                // return moment(o.purchase_date || o.created_at).format('YYYY-MM-DDTHH:mm:ss.SSS');
                return new Date(o.purchase_date_id);
            }, ['desc']);
        } else if (sorting.id === 'old') {
            this.myContents = _.orderBy(this.myContents, (o) => {
                //  moment(o.purchase_date || o.created_at).format('YYYY-MM-DDTHH:mm:ss.SSS');
                return new Date(o.purchase_date_id);
            }, ['asc']);
        }
        this.myContents.forEach((val) => {
            console.log(val.purchase_date_id);
        });
    }

    getBundlecontent(bundleID) {
        const body = { 'ID': bundleID };
        this._dataService.post('/auth/getBundleItems', body)
            .subscribe(
                (data: { data: Array<any>, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        this.bundleContent = data.data;
                        this.isDownload = true;
                        this._router.navigate(['/download', bundleID]);
                    }
                },
                (error) => {
                    this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                });
    }

    menuToggle() {
        this.menuEnableDisableToggle = this.menuEnableDisableToggle === true ? false : true;
        if (this.menuEnableDisableToggle) {
            this.menuToggleEnableDisable = "collapse navbar-collapse text-center justify-content-end";
        } else {
            this.menuToggleEnableDisable = "navbar-collapse text-center justify-content-end show";
        }
    }

    ngOnDestroy() {
        if (!!this.searchObserverSubscription.unsubscribe)
            this.searchObserverSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./public/app/modules/my-content/my-content.component.ts